import L from 'leaflet';

const Map = function(id, options) {
	this.mapTiles = L.tileLayer('https://maps.odenserundt.dk/styles/Odense/rendered/{z}/{x}/{y}.png', {attribution: '<a href="javascript:;" onclick="window.open(\'http://www.openstreetmap.org/copyright\', \'_system\');">© OpenStreetMap</a>-bidragsydere'});
	this.map = false; // Map variabel
	this.mapId; // Id of the html element for the map canvas
	this.userscreen_width; // Width of the users screen
	this.userscreen_height; // Height of the users screen
	this.addZoomControl = true;
	this.addAttribution = true;
	this.controlPosition = 'topright'; // Location of the zoom control (topleft, topright, bottomleft, bottomright)
	this.startZoom = 14; // Zoom level at map startup
	this.center = new L.LatLng(55.397817, 10.385950); // Center coordinates of the map at startup (Lat, lng)
	this.callback; // Callback function for when map has been initialized
	this.fullScreenMap = false; //Does the map resize to full size of the viewport. If false, resizes to the full size of the mapId element

	// Map boundaries
	this.northWest = L.latLng(55.849443, 9.225017);
	this.southEast = L.latLng(54.630749, 11.137016);
	this.mapBounds = L.latLngBounds(this.northWest, this.southEast);

	this.mapId = id;
	if(options.callback != undefined) {
		this.callback = options.callback;
	}
	if(options.center != undefined && options.center != '') {
		this.center = new L.LatLng(options.center.lat, options.center.lng);
	}
	if(options.controlPosition != undefined) {
		this.controlPosition = options.controlPosition;
	}
	if(options.startZoom != undefined && options.startZoom != '') {
		this.startZoom = options.startZoom;
	}
	if(options.addZoomControl != undefined) {
		this.addZoomControl = options.addZoomControl;
	}
	if(options.addAttribution != undefined) {
		this.addAttribution = options.addAttribution;
	}
	if(options.fullScreenMap != undefined) {
		this.fullScreenMap = options.fullScreenMap;
	}

	this.initMap = function(id, options){
		this.map = L.map(this.mapId, {
			center: this.center,
			zoom: this.startZoom,
			layers: this.mapTiles,
			minZoom: 8,
			zoomControl: false,
			attributionControl: false,
			maxBounds: this.mapBounds,
		});

		if(this.addZoomControl == true) {
			this.zoomControl = L.control.zoom({position: this.controlPosition});
			this.map.addControl(this.zoomControl);
		}

		if(this.addAttribution == true) {
			this.attributionControl = L.control.attribution();
			this.map.addControl(this.attributionControl);
			this.attributionControl.setPosition('bottomleft');
		}

		if(this.callback != undefined) {
			this.callback();
		}

		L.Util.requestAnimFrame(this.map.invalidateSize, this.map, false, this.map._container);

		return this;
	};

	this.disableAll = function(){
		this.map.dragging.disable();
		this.map.touchZoom.disable();
		this.map.doubleClickZoom.disable();
		this.map.scrollWheelZoom.disable();
		this.map.boxZoom.disable();
		this.map.keyboard.disable();
		if (this.map.tap) this.map.tap.disable();
	}

	this.initMap();

	/*this.applySettings = function(s, el){
		if(s == undefined){
			return;
		}

		if(s.fullscreen == true){
			el.style.height = "100%";
			el.style.width = "100%";
		}
	};*/


	/*if(id != undefined){
		return this.init(id, s);
	}*/

	return this;
};

export default Map;
